import BrandIntroSectionFa from './BrandIntroSection-fa.json';
import BrandIntroSectionEn from './BrandIntroSection-en.json';
import BrandIntroSectionAr from './BrandIntroSection-ar.json';
import BrandIntroSectionTr from './BrandIntroSection-tr.json';

import FutureMedicineFa from './FutureMedicine-fa.json';
import FutureMedicineEn from './FutureMedicine-en.json';
import FutureMedicineAr from './FutureMedicine-ar.json';
import FutureMedicineTr from './FutureMedicine-tr.json';

import HealthLocationInnovationFa from './HealthLocationInnovation-fa.json';
import HealthLocationInnovationEn from './HealthLocationInnovation-en.json';
import HealthLocationInnovationAr from './HealthLocationInnovation-ar.json';
import HealthLocationInnovationTr from './HealthLocationInnovation-tr.json';

import HomeHeroSectionFa from './HomeHeroSection-fa.json';
import HomeHeroSectionEn from './HomeHeroSection-en.json';
import HomeHeroSectionAr from './HomeHeroSection-ar.json';
import HomeHeroSectionTr from './HomeHeroSection-tr.json';

import HomeUserPersonasFa from './HomeUserPersonas-fa.json';
import HomeUserPersonasEn from './HomeUserPersonas-en.json';
import HomeUserPersonasAr from './HomeUserPersonas-ar.json';
import HomeUserPersonasTr from './HomeUserPersonas-tr.json';

import ProductIntroFa from './ProductIntro-fa.json';
import ProductIntroEn from './ProductIntro-en.json';
import ProductIntroAr from './ProductIntro-ar.json';
import ProductIntroTr from './ProductIntro-tr.json';

import SupportSectionFa from './SupportSection-fa.json';
import SupportSectionEn from './SupportSection-en.json';
import SupportSectionAr from './SupportSection-ar.json';
import SupportSectionTr from './SupportSection-tr.json';

import AiFeatureFa from './ai-feature-fa.json';
import AiFeatureEn from './ai-feature-en.json';
import AiFeatureAr from './ai-feature-ar.json';
import AiFeatureTr from './ai-feature-tr.json';

export const homeLocales = {
  fa: {
    brandIntro: BrandIntroSectionFa,
    FutureMedicine: FutureMedicineFa,
    HealthLocationInnovation: HealthLocationInnovationFa,
    home: HomeHeroSectionFa,
    HomeUserPersonas: HomeUserPersonasFa,
    productIntro: ProductIntroFa,
    SupportSection: SupportSectionFa,
    "ai-feature": AiFeatureFa,
  },
  en: {
    brandIntro: BrandIntroSectionEn,
    FutureMedicine: FutureMedicineEn,
    HealthLocationInnovation: HealthLocationInnovationEn,
    home: HomeHeroSectionEn,
    HomeUserPersonas: HomeUserPersonasEn,
    productIntro: ProductIntroEn,
    SupportSection: SupportSectionEn,
    "ai-feature": AiFeatureEn,
  },
  ar: {
    brandIntro: BrandIntroSectionAr,
    FutureMedicine: FutureMedicineAr,
    HealthLocationInnovation: HealthLocationInnovationAr,
    home: HomeHeroSectionAr,
    HomeUserPersonas: HomeUserPersonasAr,
    productIntro: ProductIntroAr,
    SupportSection: SupportSectionAr,
    "ai-feature": AiFeatureAr,
  },
  tr: {
    brandIntro: BrandIntroSectionTr,
    FutureMedicine: FutureMedicineTr,
    HealthLocationInnovation: HealthLocationInnovationTr,
    home: HomeHeroSectionTr,
    HomeUserPersonas: HomeUserPersonasTr,
    productIntro: ProductIntroTr,
    SupportSection: SupportSectionTr,
    "ai-feature": AiFeatureTr,
  },
};